angular.module('unica_workshop_session.workshop_session_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// WORKSHOP SESSION
		.state('app.workshop_session', {
			url: '/workshop-session',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/workshop-session/templates/workshop-session.html',
					controller: 'WorkshopSessionBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// WORKSHOP SESSION LIST
			.state('app.workshop_session.list', {
				url: '/list/:event_id/:workshop_id',
				views: {
					'workshopSessionContent': {
						templateUrl: './modules/workshop-session/templates/list.html',
						controller: 'WorkshopSessionListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: '{{ workshopData.title }} - Sessioni',
					parent: function($scope) {
						return 'app.workshop.list({event_id:' + $scope.event_id + '})';
					}
				}
			})

			// WORKSHOP SESSION CREATE
			.state('app.workshop_session.create', {
				url: '/create/:event_id/:workshop_id',
				views: {
					'workshopSessionContent': {
						templateUrl: './modules/workshop-session/templates/create.html',
						controller: 'WorkshopSessionCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Crea Sessione Workshop',
					parent: 'app.workshop_session.list'
				}
			})

			// WORKSHOP SESSION EDIT
			.state('app.workshop_session.edit', {
				url: '/edit/:event_id/:workshop_id/:id',
				views: {
					'workshopSessionContent': {
						templateUrl: './modules/workshop-session/templates/edit.html',
						controller: 'WorkshopSessionEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Sessione Workshop',
					parent: 'app.workshop_session.list'
				}
			});


});

